import { Link } from 'react-router-dom';

export default function ContactCTA() {
  return (
    <section className="py-20 md:py-28 px-6 md:px-12 lg:px-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto text-center">
        <h2 className="text-2xl md:text-4xl lg:text-5xl font-heading font-light text-foreground-950 tracking-[0.06em] leading-[1.3]">
          資料ダウンロード
        </h2>
        <p className="mt-5 text-sm md:text-base text-foreground-500 tracking-[0.08em] font-sans font-light">
          2025年 カード決済リスク白書
        </p>
        <div className="mt-8">
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-primary-800 text-accent-400 text-sm md:text-base tracking-[0.08em] font-sans font-medium hover:bg-primary-700 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            PDFをダウンロード
            <i className="ri-download-line text-lg" />
          </Link>
        </div>

        {/* Report Cover Image */}
        <div className="mt-14 max-w-2xl mx-auto">
          <div className="w-full aspect-[16/9] rounded-lg overflow-hidden bg-background-100">
            <img
              src="https://readdy.ai/api/search-image?query=Professional%20clean%20mockup%20of%20a%20corporate%20white%20paper%20report%20cover%20on%20a%20white%20desk%2C%20minimalist%20Japanese%20design%2C%20dark%20navy%20and%20gold%20color%20scheme%2C%20geometric%20patterns%2C%20premium%20corporate%20document%2C%20top-down%20view%2C%20soft%20natural%20lighting%2C%20clean%20composition&width=1280&height=720&seq=contact-whitepaper&orientation=landscape"
              alt="カード決済リスク白書"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}